// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');
$export($export.S, 'Date', {
  now: function () {
    return new Date().getTime();
  }
});